import { createContext } from '@smartsheet/lodestar-utils';
import { SdsToastManager, Toaster } from '@smartsheet/sds-toast-ui';
import { useContext, useMemo } from 'react';
import * as React from 'react';

const SDSToastManagerContext = createContext<{ toastManager: SdsToastManager }>({ toastManager: new SdsToastManager() }, 'SDSToastManagerContext');

export interface SDSToastProviderProps {
    /**
     * Children to render in the ToastProvider.
     */
    children: React.ReactNode;

    /**
     * The toast manager to use. (Optional, the manager is managed internally if not provided.)
     */
    manager?: SdsToastManager;
}

export const SDSToastProvider = ({ children, manager }: SDSToastProviderProps) => {
    const toastManager = useMemo(() => manager || new SdsToastManager(), [manager]);

    return (
        <SDSToastManagerContext.Provider value={{ toastManager }}>
            <Toaster manager={toastManager} />
            {children}
        </SDSToastManagerContext.Provider>
    );
};

SDSToastProvider.displayName = 'SDSToastProvider';

export const useToastManager = () => useContext(SDSToastManagerContext);
